import React from "react";
import styled from "styled-components";
import { FontSize } from "../../themes/Fonts";
import Styles from "../../themes/Styles";

const AlertContainer = styled.div`
    background-color: ${(props) => props.theme.backgroundSpecial};
    border-radius: ${Styles.borderRadiusNormal};
    padding: 10px 15px;
    font-size: ${FontSize.small};
    color: ${(props) => props.theme.textColorPrimary};
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`;

export interface LifeAtAlertProps {
    readonly toastContent: JSX.Element;
    readonly button?: JSX.Element;
    readonly className?: string;
}
export default function LifeAtToastContainer(props: LifeAtAlertProps) {
    return (
        <AlertContainer className={props.className}>
            {props.toastContent}
            {props.button}
        </AlertContainer>
    );
}
